"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultThumbnail = void 0;
exports.defaultThumbnail = {
    '6': {
        // name: 'Documents',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/6Of7tfYJ5IA/2e26abf3614f7097a34e8b30f38e8788.jpg?1661197288',
    },
    '786': {
        // name: 'Social Posts',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/AMAwQg2NI-g/a6540dcdf6a80e3d79eb25e3d286719a.jpg?1688161104',
    },
    '805': {
        // name: 'Social Covers',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/uWqQtiGLYYT/04993260f31f90e25390d870f65c8b50.jpg?1660050303',
    },
    '806': {
        // name: 'Banner Ads',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/ZGN1DMYqVcw/01582f3dedc1ff5abbc5ef3dea0b9cb8.jpg?1661171446',
    },
    '808': {
        // name: 'Web Graphics',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/sSQfXgCy0Ax/f498ed5d6f54a130b417739404fc8bb7.jpg?1660590064',
    },
    '1086': {
        // name: 'Logos',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/8YZT7BYu9kN/0d8d800a40f9f21138c380f5f34628c8.jpg?1675712302',
    },
    '1089': {
        // name: 'Flyers',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/cQjwpaAnDlA/1115d0add542443655630c31028e2671.jpg?1659637036',
    },
    '1090': {
        // name: 'Posters',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/cQjwpaAn-PA/175f4902784b4223b3d05e7b49e971d7.jpg?1680269947',
    },
    '1091': {
        // name: 'Presentations',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/CMBuFdKZpmA/4ea35de42353c02149a715e9279a6cc0.jpg?1644277882',
    },
    '1092': {
        // name: 'Business Cards',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/_0UvmaKlWow/ac91bb50365e41153f056a7bcce846bc.jpg?1655497577',
    },
    '1461': {
        // name: 'Certificates',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/hOfRd9AqmCB/7134cd7f6a545c19e844ebfa5e9e9199.jpg?1654704723',
    },
    '1463': {
        // name: 'Invitations',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/LEqKdMMXae8/d876f02daba683910928db11181c7e98.jpg?1683798434',
    },
    '1465': {
        // name: 'Visionboards',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/sSQfXgDNgfx/2524312103ad3ba253b6d52eea4b6491.jpg?1664216190',
    },
    '1467': {
        // name: 'Price List & Menus',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/-M7QpDCYhiY/ccd48dbc971f9c8da2cc15c15bee055a.jpg?1688047440',
    },
    '1468': {
        // name: 'Books Covers',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/SMiJWcOHnKU/20c0e4d39e1cade64e2c6cd091dbcfe8.jpg?1660234215',
    },
    '1469': {
        // name: 'Resumes & CVs',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/kEBhHlQui28/3a4bb5c7e79aabb6e38891349e8791b5.jpg?1682661840',
    },
    '2654': {
        // name: 'Greeting Cards',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/XGrmmdYmBmQ/ed85d2363e15eb40814bff4659fc41f5.jpg?1663350895',
    },
    '2656': {
        // name: 'Newsletters',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/HO6xCE2u7x7/e120e2b3487943e3dd1cf623da9cc988.jpg?1640757327',
    },
    '3541': {
        // name: 'Album Covers',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/7SBuECSZpfH/71153287644786f8589a1db0a86c772f.jpg?1638344392',
    },
    '33645': {
        // name: 'Quote Set Social Media',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/lOVn7aYhNDd/07d783b3d1340c05dddff612b0a38bc7.jpg?1662531511',
    },
    '33646': {
        // name: 'Event Set',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/6Of7tfYkKFA/546d0d1674cfe0f98119c2e65ead2eda.jpg?1683080865',
    },
    '33669': {
        // name: 'Social Media Set',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/7SBuECSXH-H/b1fd44ee9d4eb4e5a2625277392d2e42.jpg?1662530832',
    },
    '33702': {
        // name: 'Photo collage',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/fYrvGL29i-N/27b0baacd2ab04598b123e8062081359.jpg?1683081962',
    },
    '48147': {
        // name: 'Small Welcome Kit',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/jYB8RHE-qFa/021206e004e093d05372bf0f49fbb1b2.jpg?1683075443',
    },
    '76876': {
        // name: 'Stationery Items',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/zAzI9LZYd8W/79b5aeb4f7ba2c4750fc99beebd58288.jpg?1682707767',
    },
    '276996': {
        // name: 'Brochures',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/e4RAEIB0I-k/ce95e42e81d66275a75bc4e29e92ebdd.jpg?1683857692',
    },
    '290295': {
        // name: 'Pride Month',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/OINxqb3o5PO/43219070e06f1f78638d950a988b6764.jpg?1684918464',
    },
    '303774': {
        // name: 'Digital Business Cards',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/DGu9DBWApab/ee250e2c0aa8b501893fe2f4cd09fe29.jpg?1674450490',
    },
    '303848': {
        // name: 'Digital Price List',
        thumbnail: 'https://s3.amazonaws.com/virginia.webrand.com/virginia/344/TUjmSfBWM-2/9f29ff4505dae83699a18e45f35e40d1.jpg?1623936728',
    },
};
//# sourceMappingURL=Thumbnail.js.map